import { render, staticRenderFns } from "./QueryRelationship.vue?vue&type=template&id=2c3acc1c&scoped=true"
import script from "./QueryRelationship.vue?vue&type=script&lang=js"
export * from "./QueryRelationship.vue?vue&type=script&lang=js"
import style0 from "./QueryRelationship.vue?vue&type=style&index=0&id=2c3acc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3acc1c",
  null
  
)

export default component.exports